export const Append_0 = function (number, width) {
  return (
    new Array(+width + 1 - (parseInt(number) + '').length).join('0') +
    parseInt(number)
  );
};
